import {LiveDashboard} from "@common/ui-components/live/live-dashboard/live-dashboard";
import collection from "./section-and-text-chart-collection.json";
import data from "./section-and-text-chart-data.json";

export const SectionAndTextTileThemeAuto = (props) => {
    return LiveDashboard({
        collection,
        defaultData: data,
        disabledTileActions: true,
        ...props,
    });
};
